'use strict';

var cloudinary = require('cloudinary-core');

module.exports = cloudinary.Cloudinary['new']();